export const ActivityValues = [
  { value: 'openTasks', title: 'Open Tasks' },
  { value: 'dueTodayTasks', title: 'Due Today' },
  { value: 'stuckTasks', title: 'Stuck' },
  { value: 'overdueTasks', title: 'Overdue' },
  { value: 'pendingTourRequests', title: 'Pending Tour Requests' },
  { value: 'openOffers', title: 'Open Offers' },
  { value: 'expiringOffers', title: 'Expiring Offers' },
  { value: 'pendingShowingRequests', title: 'Pending Showing Requests' },
  { value: 'pendingSignatures', title: 'Pending Signatures' },
];
export const ClientsValues = [
  { value: 'activeClients', title: 'Active' },
  { value: 'pendingClients', title: 'Pending' },
  { value: 'buyers', title: 'Buyers' },
  { value: 'sellers', title: 'Sellers' },
  { value: 'retentionClients', title: 'Retention' },
  {
    value: 'nonKitRetentionClients',
    title: 'Retention (not enrolled in KIT Sequence)',
  },
];
export const ListingValues = [
  { value: 'preListing', title: 'Pre-Listing' },
  { value: 'officeExclusive', title: 'Office Exclusive' },
  { value: 'comingSoon', title: 'Coming Soon' },
  { value: 'activeListing', title: 'Active Listing' },
  { value: 'onHold', title: 'TNAS' },
  { value: 'underContractListing', title: 'Under Contract' },
];
export const PurchaseValues = [
  { value: 'underContractPurchase', title: 'Under Contract' },
  { value: 'clearToClose', title: 'Clear to Close' },
];
export const DualValues = [
  { value: 'preListingDual', title: 'Pre-Listing' },
  { value: 'officeExclusiveDual', title: 'Office Exclusive' },
  { value: 'comingSoonDual', title: 'Coming Soon' },
  { value: 'activeListingDual', title: 'Active Listing' },
  { value: 'onHoldDual', title: 'TNAS' },
  { value: 'underContractDual', title: 'Under Contract' },
  { value: 'clearToCloseDual', title: 'Clear to Close' },
];

const allValueGroups = [
  ...ActivityValues,
  ...ClientsValues,
  ...ListingValues,
  ...PurchaseValues,
  ...DualValues,
];

const clientModalNameMaps = {
  Active: 'Active Clients',
  Pending: 'Pending Clients',
  Buyers: 'Buyer Clients',
  Sellers: 'Seller Clients',
  Retention: 'Retention Clients',
  'Retention (not enrolled in KIT Sequence)': 'Retention (not enrolled in KIT Sequence) Clients',
};

export function getTitleFromValue(value: string, isClientsModal: boolean): string | undefined {
  const title = allValueGroups.find((item) => item.value === value)?.title || '';
  return isClientsModal && clientModalNameMaps?.[title] ? clientModalNameMaps?.[title] : title;
}

export const SymphonyColumns = {
  activity: [],
  clients: [],
  listing: [],
  purchase: [],
  dual: [],
};

export const getSelectedParams = (selected = SymphonyColumns) => {
  const result: any = {};
  Object.values(selected)
    .flat()
    .forEach((value) => {
      result[value] = true;
    });
  return result;
};

export const parsePreference = (preference: string[] = []) => {
  const result = {
    activity: [] as string[],
    clients: [] as string[],
    listing: [] as string[],
    purchase: [] as string[],
    dual: [] as string[],
  };

  const valueMap: Record<string, keyof typeof result> = {};

  ActivityValues.forEach(({ value }) => (valueMap[value] = 'activity'));
  ClientsValues.forEach(({ value }) => (valueMap[value] = 'clients'));
  ListingValues.forEach(({ value }) => (valueMap[value] = 'listing'));
  PurchaseValues.forEach(({ value }) => (valueMap[value] = 'purchase'));
  DualValues.forEach(({ value }) => (valueMap[value] = 'dual'));

  preference.forEach((value) => {
    const key = valueMap[value];
    if (key) {
      result[key].push(value);
    }
  });

  return result;
};
